export enum Identifier {
  TYPE_API_KEY = 'apiKey',
  TYPE_TOKEN = 'token',
  TYPE_USER = 'user',
  TYPE_CLINIC = 'clinic',
  TYPE_CLINIC_GROUP_ID = 'clinicGroupId',
  TYPE_CLINIC_ID = 'clinicId',
  TYPE_LANGUAGE = 'culture',
  TYPE_FRANCHISE_ID = 'clinicGroupFranchiseId',
  TYPE_FRANCHISE_LANGUAGE_IDS = 'clinicFranchiseSupportedLanguageIds',
  TYPE_VISIBLE_MENUS = 'visibleMenus',
  TYPE_ENABLED_ACTIONS = 'enabledActions',
  TYPE_CLINIC_MODULES = 'clinicModules',
  TYPE_READ_ONLY = 'readOnly',
}
